export default {
  status: {
    completed: '已完成',
    pending: '待确认',
    rejected: {
      action: '拒单',
      state: '已拒绝',
    },
    doing: '制作中',
    revoked: {
      state: '已撤回',
      action: '撤回',
    },
    unpaid: '未支付',
    paid: '已支付',
    fail: '支付失败',
  },
  list: {
    revoked: '撤回成功',
  },
  '3dmodel': {
    title: '3D模型工单 (Beta)',
    handle: '3D模型处理',
    dialog: {
      modelManage: '模型工单管理',
      serviceExplain: '服务说明',
      submit: '提交模型处理需求',
      confirm: '确定',
      resubmit: '重新上传',
      success:
        '您的需求已成功提交，我们将在1个工作日内回复交付时间。您可以在“我的资产 - 3D模型工单”中查看具体进度。如有任何疑问，请联系我们：support@mindworks-creative.com。',
    },
    tips: {
      upload:
        '*请上传您的模型，我们团队将按照平台的制作规范和要求进行处理，以确保模型与平台兼容并获得最佳表现效果。 在您提交模型后的 1 个工作日内，我们会回复您预计的交付时间。可前往 创意资产 - 3D模型工单 查看。',
      credits: '模型处理需消耗 {count} 点（剩余 {balance} 点）',
      money: '模型处理需消耗 {count}（剩余 {balance}）',
      videoSubmit:
        '模型处理需消耗 {count} 点（剩余 {balance} 点）。确定提交吗？在您提交模型后的 1 个工作日内，我们会回复您预计的交付时间。可前往 我的资产 - 3D 模型工单 查看。',
      moneySubmit:
        '模型处理需消耗 $ {count}（剩余 $ {balance}）。确定提交吗？在您提交模型后的 1 个工作日内，我们会回复您预计的交付时间。可前往 我的资产 - 3D 模型工单 查看。',
      moneyTooltip: '当工单交付时，余额会被扣除并出账。',
      remark: '请输入备注',
      revoke: '确定撤回此 3D 模型工单吗？',
    },
    uploader: {
      require:
        '请拖放或上传 zip 格式文件，zip 包内仅支持包含 FBX、.ma、.mb、.max、.glb、(.gltf+bin) 格式的模型文件，以及 png、jpg 格式的贴图文件',
      format: '格式',
      require1: '三角面数 < 10000, 顶点数 < 8000, Mesh = 1',
      require2: '贴图数 >= 1',
      nosupportFormat: '不支持的文件格式',
      missModelFile: '缺少模型文件',
      warning: {
        triangles: '三角面数 < 10000',
        vertex: '顶点数 < 8000',
        mesh: 'Mesh = 1',
        contentError: '文件内容错误。',
        picCountError: '文件内容错误。不满足贴图数>=1。',
      },
    },
    service: '模型处理服务 (Beta)',
    tip: '提供3D模型处理服务，我们将按照平台的制作规范和要求进行处理，以确保模型可在换肤编辑器内使用。',
  },
  name: '工单',
  table: {
    column: {
      remark: '备注',
      status: '状态',
      relativeProject: '关联项目',
      estimatedDeliverTime2: '预计交付时间',
      deliverTime: '实际交付时间',
      categoryName: '坑位名',
      createdTime: '工单创建时间',
      usageType: '支付类型',
      balance: '余额',
      videoCredits: '点数',
      deduction: '扣减数',
      count: '{count} 点',
    },
  },
  filter: {
    modelName: '模型名称',
    orderId: '工单ID',
    statusOptions: '选择状态',
    '3dmodel': '3D模型',
  },
}
